import React from 'react';
import { Button, Grid, Icon } from 'tabler-react';

class SubscriptionIdCard extends React.Component {
    state = {
        showCopiedLabel: false
    };

    copy = () => {
        this.setState({showCopiedLabel: true}, () => {
            setTimeout(() => this.setState({showCopiedLabel: false}), 3000);
        });
    };

    render = () => {
        return (
            <Grid.Row className="mt-4">
                <Grid.Col>
                    <div className="subscription-id">
                        <h6 className="title">Código da Assinatura</h6>
                        <span className="hash lead">#</span>
                        <span className="id">
                            {this.props.id}
                            {
                                1===2 &&
                                <Button onClick={this.copy}>
                                    <Icon name="copy"/>
                                </Button>
                            }
                        {
                            this.state.showCopiedLabel &&
                            <small className="text-sm-left text-blue">copiado.</small>
                        }

                    </span>
                    </div>
                </Grid.Col>
            </Grid.Row>
        );
    }
}

export default SubscriptionIdCard;